/**
 * Hook de récupération des actualités pour une catégorie donnée.
 * Gère les états chargement / erreur et l'horodatage de la dernière mise à jour.
 */
import { useEffect, useState } from "react";
import { fetchNews, NewsCategory, NewsItem } from "../../../../api/news";

type UseNewsResult = {
  items: NewsItem[];
  loading: boolean;
  error: boolean;
  updatedAt: Date | null;
};

export function useNews(category: NewsCategory | "all" = "all"): UseNewsResult {
  const [items, setItems] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [updatedAt, setUpdatedAt] = useState<Date | null>(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);

    fetchNews(category)
      .then((result) => {
        if (!active) return;
        setItems(result.items);
        setUpdatedAt(new Date(result.fetchedAt));
      })
      .catch(() => {
        if (active) setError(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [category]);

  return { items, loading, error, updatedAt };
}
